var module = angular.module('components');
module.component('caSearchListContactInfos', {
    templateUrl: 'components/genericcomponents/searchlist/searchlist-contactinfo.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        contactInfos: '<'
    }
});
